import React from "react";
import { Image, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { isBrowser } from "react-device-detect";

//STYLES
import * as OrderDetailsItemStyles from "../../styles/orderDetailsItem";

function OrderDetailsOverview(props) {
    const navigate = useNavigate();

    function handleOrderClick() {
        navigate(`../../orderDetails/${props.order.id}`);
    }

    const browserDisplay = (
        <div>
            <div style={OrderDetailsItemStyles.body} onClick={handleOrderClick}>
                <Row>
                    <Col md="auto">
                        <div
                            style={{
                                ...OrderDetailsItemStyles.image,
                                backgroundImage: `url(/content/3dPrintingShop/products/${props.order.firstImage.uuid.toString()}/${
                                    props.order.firstImage.name
                                })`
                            }}
                        >
                            {props.order.items > 1 && <div style={OrderDetailsItemStyles.square}>+{props.order.items - 1}</div>}
                        </div>
                    </Col>
                    <Col>
                        <Row>
                            <Col>
                                <strong>Order Placed:</strong> {props.order.dateCreated}
                                <br />
                                <strong>ID:</strong> {props.order.id} <br /> <br />
                            </Col>
                        </Row>
                        <Row>
                            <Col style={OrderDetailsItemStyles.columnRight}>
                                <strong>Postage Cost:</strong> £{(props.order.postageWhenOrdered / 100).toFixed(2)} <br />
                                <strong>Total:</strong> £ {(props.order.total / 100).toFixed(2)}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            <br />
        </div>
    );

    const mobileDisplay = (
        <div style={OrderDetailsItemStyles.mobile_body} onClick={handleOrderClick}>
            <div style={OrderDetailsItemStyles.mobile_imageContainer}>
                <div
                    style={{
                        ...OrderDetailsItemStyles.image,
                        backgroundImage: `url(/content/3dPrintingShop/products/${props.order.firstImage.uuid.toString()}/${
                            props.order.firstImage.name
                        })`
                    }}
                >
                    {props.order.items > 1 && <div style={OrderDetailsItemStyles.mobile_square}>+{props.order.items - 1}</div>}
                </div>
            </div>
            <div style={OrderDetailsItemStyles.mobile_infoContainer}>
                <div style={OrderDetailsItemStyles.mobile_orderRefs}>
                    <strong>Order Placed:</strong> {props.order.dateCreated}
                    <br />
                    <strong>ID:</strong> {props.order.id} <br /> <br />
                </div>
                <div style={OrderDetailsItemStyles.mobile_totals}>
                    <strong>Postage Cost:</strong> £{(props.order.postageWhenOrdered / 100).toFixed(2)} <br />
                    <strong>Total:</strong> £ {(props.order.total / 100).toFixed(2)}
                </div>
            </div>
        </div>
    );

    return <div>{isBrowser ? browserDisplay : mobileDisplay}</div>;
}

export default OrderDetailsOverview;
